// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResultsDetailsPopup-module__font-s-10___GuV73 {
  font-size: 10px !important;
}

.ResultsDetailsPopup-module__font-s-12___Y0osv {
  font-size: 12px !important;
}

.ResultsDetailsPopup-module__font-s-13___T8ZeW {
  font-size: 13px !important;
}

.ResultsDetailsPopup-module__font-s-14___yZWzN {
  font-size: 14px !important;
}

.ResultsDetailsPopup-module__font-s-15___D0wba {
  font-size: 15px !important;
}

.ResultsDetailsPopup-module__font-s-16___SuOIx {
  font-size: 16px !important;
}

.ResultsDetailsPopup-module__font-s-18___L5zd3 {
  font-size: 18px !important;
}

.ResultsDetailsPopup-module__font-s-20___Vgf0f {
  font-size: 20px !important;
}

.ResultsDetailsPopup-module__font-s-22___E41AP {
  font-size: 22px !important;
}

.ResultsDetailsPopup-module__font-s-28___NJKDq {
  font-size: 28px !important;
}

.ResultsDetailsPopup-module__font-w-400___cEB48 {
  font-weight: 400 !important;
}

.ResultsDetailsPopup-module__font-w-500___e16Y0 {
  font-weight: 500 !important;
}

.ResultsDetailsPopup-module__font-w-600___Cm0Os {
  font-weight: 600 !important;
}

.ResultsDetailsPopup-module__font-w-700___cYznI {
  font-weight: 700 !important;
}

.ResultsDetailsPopup-module__p-5___SlTNU {
  padding: 5px !important;
}

.ResultsDetailsPopup-module__p-12___awhfc {
  padding: 12px !important;
}

.ResultsDetailsPopup-module__p-16___AoJCm {
  padding: 16px !important;
}

.ResultsDetailsPopup-module__p-30___wfImp {
  padding: 30px !important;
}

.ResultsDetailsPopup-module__p-b-0___rU5hb {
  padding-bottom: 0 !important;
}

.ResultsDetailsPopup-module__p-b-5___yqrtu {
  padding-bottom: 5px !important;
}

.ResultsDetailsPopup-module__p-b-10___pm13w {
  padding-bottom: 10px !important;
}

.ResultsDetailsPopup-module__p-b-12___SfXZH {
  padding-bottom: 12px !important;
}

.ResultsDetailsPopup-module__p-b-16___NEWk6 {
  padding-bottom: 16px !important;
}

.ResultsDetailsPopup-module__p-b-18___Jwbg9 {
  padding-bottom: 18px !important;
}

.ResultsDetailsPopup-module__p-b-20___hkywx {
  padding-bottom: 20px !important;
}

.ResultsDetailsPopup-module__p-b-25___GBJ2c {
  padding-bottom: 25px !important;
}

.ResultsDetailsPopup-module__p-b-30___qEDNq {
  padding-bottom: 30px !important;
}

.ResultsDetailsPopup-module__p-b-50___WNb7n {
  padding-bottom: 50px !important;
}

.ResultsDetailsPopup-module__p-t-0___ROxJt {
  padding-top: 0 !important;
}

.ResultsDetailsPopup-module__p-t-12___EtLPT {
  padding-top: 12px !important;
}

.ResultsDetailsPopup-module__p-t-16___Henk7 {
  padding-top: 16px !important;
}

.ResultsDetailsPopup-module__p-t-18___kPIOj {
  padding-top: 18px !important;
}

.ResultsDetailsPopup-module__p-t-20___pjGiv {
  padding-top: 20px !important;
}

.ResultsDetailsPopup-module__p-t-30___bpqUR {
  padding-top: 30px !important;
}

.ResultsDetailsPopup-module__p-t-40___Tt8fp {
  padding-top: 40px !important;
}

.ResultsDetailsPopup-module__p-t-50___ubzmr {
  padding-top: 50px !important;
}

.ResultsDetailsPopup-module__p-l-20___NuLKq {
  padding-left: 20px !important;
}

.ResultsDetailsPopup-module__p-l-30___AiZDi {
  padding-left: 30px !important;
}

.ResultsDetailsPopup-module__p-l-40___Vb_UF {
  padding-left: 40px !important;
}

.ResultsDetailsPopup-module__p-r-16____AmQZ {
  padding-right: 16px !important;
}

.ResultsDetailsPopup-module__p-r-20___pMnrW {
  padding-right: 20px !important;
}

.ResultsDetailsPopup-module__p-r-30___ZYrj5 {
  padding-right: 30px !important;
}

.ResultsDetailsPopup-module__p-r-50___nG9Y5 {
  padding-right: 50px !important;
}

.ResultsDetailsPopup-module__p-r-60___yM6h1 {
  padding-right: 60px !important;
}

.ResultsDetailsPopup-module__m-b-1___p2MC2 {
  margin-bottom: 1px !important;
}

.ResultsDetailsPopup-module__m-b-2___m_I26 {
  margin-bottom: 2px !important;
}

.ResultsDetailsPopup-module__m-b-6___cc6Cl {
  margin-bottom: 6px !important;
}

.ResultsDetailsPopup-module__m-b-8___I178X {
  margin-bottom: 8px !important;
}

.ResultsDetailsPopup-module__m-b-10____K3Dq {
  margin-bottom: 10px !important;
}

.ResultsDetailsPopup-module__m-b-14___o09sw {
  margin-bottom: 14px !important;
}

.ResultsDetailsPopup-module__m-b-16___V7B6b {
  margin-bottom: 16px !important;
}

.ResultsDetailsPopup-module__m-b-20___YUr6z {
  margin-bottom: 20px !important;
}

.ResultsDetailsPopup-module__m-b-22___hNIRw {
  margin-bottom: 22px !important;
}

.ResultsDetailsPopup-module__m-b-24___IYTz9 {
  margin-bottom: 24px !important;
}

.ResultsDetailsPopup-module__m-b-30___IrkcA {
  margin-bottom: 30px !important;
}

.ResultsDetailsPopup-module__m-b-32___JRNrq {
  margin-bottom: 32px !important;
}

.ResultsDetailsPopup-module__m-b-40___eMrZ9 {
  margin-bottom: 40px !important;
}

.ResultsDetailsPopup-module__m-t-2___R81rG {
  margin-top: 2px !important;
}

.ResultsDetailsPopup-module__m-t-3___aqHio {
  margin-top: 3px !important;
}

.ResultsDetailsPopup-module__m-t-4___HTJgY {
  margin-top: 4px !important;
}

.ResultsDetailsPopup-module__m-t-5___fcPgi {
  margin-top: 5px !important;
}

.ResultsDetailsPopup-module__m-t-8___O_2Na {
  margin-top: 8px !important;
}

.ResultsDetailsPopup-module__m-t-10___Gt3nJ {
  margin-top: 10px !important;
}

.ResultsDetailsPopup-module__m-t-15___uDk0s {
  margin-top: 15px !important;
}

.ResultsDetailsPopup-module__m-t-16___wqxTo {
  margin-top: 16px !important;
}

.ResultsDetailsPopup-module__m-t-20___B9WQo {
  margin-top: 20px !important;
}

.ResultsDetailsPopup-module__m-t-22___aXBVM {
  margin-top: 22px !important;
}

.ResultsDetailsPopup-module__m-t-30___cRzSc {
  margin-top: 30px !important;
}

.ResultsDetailsPopup-module__m-t-32___mzrOM {
  margin-top: 32px !important;
}

.ResultsDetailsPopup-module__m-l-auto___TKouw {
  margin-left: auto !important;
}

.ResultsDetailsPopup-module__m-l-4___pmxuF {
  margin-left: 4px !important;
}

.ResultsDetailsPopup-module__m-l-5___l7yyu {
  margin-left: 5px !important;
}

.ResultsDetailsPopup-module__m-l-6___uHAcI {
  margin-left: 6px !important;
}

.ResultsDetailsPopup-module__m-l-8___Rmrb5 {
  margin-left: 8px !important;
}

.ResultsDetailsPopup-module__m-l-10___fidbS {
  margin-left: 10px !important;
}

.ResultsDetailsPopup-module__m-l-16___njBJV {
  margin-left: 16px !important;
}

.ResultsDetailsPopup-module__m-l-20___qyQrm {
  margin-left: 20px !important;
}

.ResultsDetailsPopup-module__m-l-24___vjjHB {
  margin-left: 24px !important;
}

.ResultsDetailsPopup-module__m-l-30___nVx_W {
  margin-left: 30px !important;
}

.ResultsDetailsPopup-module__m-l-35___Dz6U0 {
  margin-left: 35px !important;
}

.ResultsDetailsPopup-module__m-l-40___IkFT6 {
  margin-left: 40px !important;
}

.ResultsDetailsPopup-module__m-r-8___E9iXS {
  margin-right: 8px !important;
}

.ResultsDetailsPopup-module__m-r-10___pUJE9 {
  margin-right: 10px !important;
}

.ResultsDetailsPopup-module__m-r-16___tTc1q {
  margin-right: 16px !important;
}

.ResultsDetailsPopup-module__m-r-20___plZ2p {
  margin-right: 20px !important;
}

.ResultsDetailsPopup-module__m-r-24___QtjcJ {
  margin-right: 24px !important;
}

.ResultsDetailsPopup-module__m-r-30___YHO__ {
  margin-right: 30px !important;
}

.ResultsDetailsPopup-module__m-r-40___NYk2U {
  margin-right: 40px !important;
}

.ResultsDetailsPopup-module__border-r-3___UWWmy {
  border-radius: 3px !important;
}

.ResultsDetailsPopup-module__border-r-4___gPdwo {
  border-radius: 4px !important;
}

.ResultsDetailsPopup-module__border-r-6___ZPqQq {
  border-radius: 6px !important;
}

.ResultsDetailsPopup-module__border-r-10___Gc_a4 {
  border-radius: 10px !important;
}

.ResultsDetailsPopup-module__border-r-12___pFsvT {
  border-radius: 12px !important;
}

.ResultsDetailsPopup-module__border-r-16___i2xP9 {
  border-radius: 16px !important;
}

.ResultsDetailsPopup-module__border-r-50___kvTPJ {
  border-radius: 50% !important;
}

.ResultsDetailsPopup-module__primary-border___aYMu0 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ResultsDetailsPopup-module__primary-border-b___CYxuN {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ResultsDetailsPopup-module__primary-border-t___WUOWr {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ResultsDetailsPopup-module__primary-border-l___ZhHVk {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ResultsDetailsPopup-module__primary-border-r___DQVPw {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ResultsDetailsPopup-module__secondary-border___Ibbu_ {
  border: 1px solid #637768;
}

.ResultsDetailsPopup-module__secondary-border-b___r5SMP {
  border-bottom: 1px solid #637768;
}

.ResultsDetailsPopup-module__secondary-border-t___RbNMP {
  border-top: 1px solid #637768;
}

.ResultsDetailsPopup-module__secondary-border-l___Kyx3L {
  border-left: 1px solid #637768;
}

.ResultsDetailsPopup-module__secondary-border-r___g62Ic {
  border-right: 1px solid #637768;
}

.ResultsDetailsPopup-module__gap-0___LUB7t {
  gap: 0 !important;
}

.ResultsDetailsPopup-module__gap-2___ifpij {
  gap: 2px !important;
}

.ResultsDetailsPopup-module__gap-4___pI37n {
  gap: 4px !important;
}

.ResultsDetailsPopup-module__gap-5___sAiCQ {
  gap: 5px !important;
}

.ResultsDetailsPopup-module__gap-6___blFvT {
  gap: 6px !important;
}

.ResultsDetailsPopup-module__gap-8___VS16g {
  gap: 8px !important;
}

.ResultsDetailsPopup-module__gap-10___n4C5B {
  gap: 10px !important;
}

.ResultsDetailsPopup-module__gap-12___rqTxu {
  gap: 12px !important;
}

.ResultsDetailsPopup-module__gap-14___h1DI_ {
  gap: 14px !important;
}

.ResultsDetailsPopup-module__gap-16___O0s96 {
  gap: 16px !important;
}

.ResultsDetailsPopup-module__gap-18___BdijS {
  gap: 18px !important;
}

.ResultsDetailsPopup-module__gap-20___xJ1dA {
  gap: 20px !important;
}

.ResultsDetailsPopup-module__gap-24___DHjro {
  gap: 24px !important;
}

.ResultsDetailsPopup-module__gap-26___puvD5 {
  gap: 26px !important;
}

.ResultsDetailsPopup-module__gap-30___MmSwY {
  gap: 30px !important;
}

.ResultsDetailsPopup-module__gap-32____0MA7 {
  gap: 32px !important;
}

.ResultsDetailsPopup-module__gap-40___SHm9N {
  gap: 40px !important;
}

.ResultsDetailsPopup-module__gap-50___QdWNT {
  gap: 50px !important;
}

.ResultsDetailsPopup-module__flex-1___BPDyB {
  flex: 1;
}

.ResultsDetailsPopup-module__flex-none___oqgRi {
  flex: none !important;
}

.ResultsDetailsPopup-module__flex-column___YdfKr {
  display: flex;
  flex-direction: column !important;
}

.ResultsDetailsPopup-module__flex-row___aTRLO {
  display: flex;
  flex-direction: row !important;
}

.ResultsDetailsPopup-module__vertically-centered___JpeN6 {
  display: flex;
  align-items: center !important;
}

.ResultsDetailsPopup-module__horizontally-centered___S35_t {
  display: flex;
  justify-content: center !important;
}

.ResultsDetailsPopup-module__horizontally-end___afyWV {
  display: flex;
  justify-content: end !important;
}

.ResultsDetailsPopup-module__vertically-start___zHO_b {
  display: flex;
  align-items: start !important;
}

.ResultsDetailsPopup-module__space-between___Fdd4z {
  display: flex;
  justify-content: space-between !important;
}

.ResultsDetailsPopup-module__flex-wrap___GIPnQ {
  flex-wrap: wrap !important;
}

.ResultsDetailsPopup-module__height-100___hfYuW {
  height: 100%;
}

.ResultsDetailsPopup-module__width-50___gkJg2 {
  width: 50% !important;
}

.ResultsDetailsPopup-module__width-100___qx19P {
  width: 100%;
}

.ResultsDetailsPopup-module__cursor-pointer___F5uUw {
  cursor: pointer;
}

.ResultsDetailsPopup-module__cursor-not-allowed___sBDsM {
  cursor: not-allowed !important;
}

.ResultsDetailsPopup-module__absolute-centered___nqLGr {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ResultsDetailsPopup-module__absolute___eSCgk {
  position: absolute;
}

.ResultsDetailsPopup-module__relative___XoQsS {
  position: relative;
}

.ResultsDetailsPopup-module__fixed___d8Zrr {
  position: fixed;
}

.ResultsDetailsPopup-module__visible___j37eW {
  opacity: 1;
}

.ResultsDetailsPopup-module__invisible___RYxxK {
  opacity: 0;
}

.ResultsDetailsPopup-module__col-90___w1Mgs {
  width: 90% !important;
}

.ResultsDetailsPopup-module__col-auto___tgFtJ {
  width: auto !important;
}

.ResultsDetailsPopup-module__medical-tabs___fa8pe {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ResultsDetailsPopup-module__medical-table-new___Mzlug {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ResultsDetailsPopup-module__medical-table-new___Mzlug:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ResultsDetailsPopup-module__medical-table-new___Mzlug::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ResultsDetailsPopup-module__medical-table-new___Mzlug::-webkit-scrollbar-track {
  display: none;
}
.ResultsDetailsPopup-module__medical-table-new___Mzlug.ResultsDetailsPopup-module__no-pagination___uc2kR {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ResultsDetailsPopup-module__medical-table-new___Mzlug.ResultsDetailsPopup-module__no-pagination___uc2kR:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ResultsDetailsPopup-module__medical-table-new___Mzlug.ResultsDetailsPopup-module__no-pagination___uc2kR::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ResultsDetailsPopup-module__medical-table-new___Mzlug.ResultsDetailsPopup-module__no-pagination___uc2kR::-webkit-scrollbar-track {
  display: none;
}

.ResultsDetailsPopup-module__medical-table-empty___qShbi {
  padding: 14px 40px !important;
}

.ResultsDetailsPopup-module__icon-btn___OCCrb {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ResultsDetailsPopup-module__search-icon___KPrXy {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ResultsDetailsPopup-module__disable-select___W37BC {
  user-select: none;
}

.ResultsDetailsPopup-module__break-word___xpopx {
  word-break: break-word;
}

.ResultsDetailsPopup-module__popup-clear-btn___W_oa3 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ResultsDetailsPopup-module__scroll-m-b-20___gd2PD {
  scroll-margin-bottom: 20px;
}

.ResultsDetailsPopup-module__info___NV7nt {
  padding: 25px 35px;
}
.ResultsDetailsPopup-module__info___NV7nt .ResultsDetailsPopup-module__source___yHlwL {
  color: #a79988;
}
.ResultsDetailsPopup-module__info___NV7nt .ResultsDetailsPopup-module__category___pLgBz {
  color: #375844;
}
.ResultsDetailsPopup-module__info___NV7nt .ResultsDetailsPopup-module__date___xp3LV {
  color: #859989;
}
.ResultsDetailsPopup-module__info___NV7nt .ResultsDetailsPopup-module__date___xp3LV > span {
  min-width: 75px;
  display: inline-block;
}

.ResultsDetailsPopup-module__table___KaAer {
  padding: 25px 35px;
  height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.ResultsDetailsPopup-module__table___KaAer:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ResultsDetailsPopup-module__table___KaAer::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ResultsDetailsPopup-module__table___KaAer::-webkit-scrollbar-track {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/ResultsDetailsPopup/ResultsDetailsPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;AA3pBE;EACE,cAAA;AA6pBJ;AA1pBE;EACE,cAAA;AA4pBJ;AA1pBI;EACE,eAAA;EACA,qBAAA;AA4pBN;;AAvpBA;EACE,kBAAA;ECdA,aDewB;ECdxB,kBAAA;EACA,kBAAA;ADyqBF;ACvqBE;EACE,oCAAA;EACA,mBAAA;ADyqBJ;ACtqBE;EACE,UAAA;EACA,6BAAA;ADwqBJ;ACrqBE;EACE,aAAA;ADuqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.info {\n  padding: 25px 35px;\n\n  .source {\n    color: get-color(orangeNew, medium-dark);\n  }\n\n  .category {\n    color: get-color(greenNew, dark);\n  }\n\n  .date {\n    color: get-color(greenNew, medium);\n\n    & > span {\n      min-width: 75px;\n      display: inline-block;\n    }\n  }\n}\n\n.table {\n  padding: 25px 35px;\n  @include verticalScroll(200px);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ResultsDetailsPopup-module__font-s-10___GuV73`,
	"fontS12": `ResultsDetailsPopup-module__font-s-12___Y0osv`,
	"fontS13": `ResultsDetailsPopup-module__font-s-13___T8ZeW`,
	"fontS14": `ResultsDetailsPopup-module__font-s-14___yZWzN`,
	"fontS15": `ResultsDetailsPopup-module__font-s-15___D0wba`,
	"fontS16": `ResultsDetailsPopup-module__font-s-16___SuOIx`,
	"fontS18": `ResultsDetailsPopup-module__font-s-18___L5zd3`,
	"fontS20": `ResultsDetailsPopup-module__font-s-20___Vgf0f`,
	"fontS22": `ResultsDetailsPopup-module__font-s-22___E41AP`,
	"fontS28": `ResultsDetailsPopup-module__font-s-28___NJKDq`,
	"fontW400": `ResultsDetailsPopup-module__font-w-400___cEB48`,
	"fontW500": `ResultsDetailsPopup-module__font-w-500___e16Y0`,
	"fontW600": `ResultsDetailsPopup-module__font-w-600___Cm0Os`,
	"fontW700": `ResultsDetailsPopup-module__font-w-700___cYznI`,
	"p5": `ResultsDetailsPopup-module__p-5___SlTNU`,
	"p12": `ResultsDetailsPopup-module__p-12___awhfc`,
	"p16": `ResultsDetailsPopup-module__p-16___AoJCm`,
	"p30": `ResultsDetailsPopup-module__p-30___wfImp`,
	"pB0": `ResultsDetailsPopup-module__p-b-0___rU5hb`,
	"pB5": `ResultsDetailsPopup-module__p-b-5___yqrtu`,
	"pB10": `ResultsDetailsPopup-module__p-b-10___pm13w`,
	"pB12": `ResultsDetailsPopup-module__p-b-12___SfXZH`,
	"pB16": `ResultsDetailsPopup-module__p-b-16___NEWk6`,
	"pB18": `ResultsDetailsPopup-module__p-b-18___Jwbg9`,
	"pB20": `ResultsDetailsPopup-module__p-b-20___hkywx`,
	"pB25": `ResultsDetailsPopup-module__p-b-25___GBJ2c`,
	"pB30": `ResultsDetailsPopup-module__p-b-30___qEDNq`,
	"pB50": `ResultsDetailsPopup-module__p-b-50___WNb7n`,
	"pT0": `ResultsDetailsPopup-module__p-t-0___ROxJt`,
	"pT12": `ResultsDetailsPopup-module__p-t-12___EtLPT`,
	"pT16": `ResultsDetailsPopup-module__p-t-16___Henk7`,
	"pT18": `ResultsDetailsPopup-module__p-t-18___kPIOj`,
	"pT20": `ResultsDetailsPopup-module__p-t-20___pjGiv`,
	"pT30": `ResultsDetailsPopup-module__p-t-30___bpqUR`,
	"pT40": `ResultsDetailsPopup-module__p-t-40___Tt8fp`,
	"pT50": `ResultsDetailsPopup-module__p-t-50___ubzmr`,
	"pL20": `ResultsDetailsPopup-module__p-l-20___NuLKq`,
	"pL30": `ResultsDetailsPopup-module__p-l-30___AiZDi`,
	"pL40": `ResultsDetailsPopup-module__p-l-40___Vb_UF`,
	"pR16": `ResultsDetailsPopup-module__p-r-16____AmQZ`,
	"pR20": `ResultsDetailsPopup-module__p-r-20___pMnrW`,
	"pR30": `ResultsDetailsPopup-module__p-r-30___ZYrj5`,
	"pR50": `ResultsDetailsPopup-module__p-r-50___nG9Y5`,
	"pR60": `ResultsDetailsPopup-module__p-r-60___yM6h1`,
	"mB1": `ResultsDetailsPopup-module__m-b-1___p2MC2`,
	"mB2": `ResultsDetailsPopup-module__m-b-2___m_I26`,
	"mB6": `ResultsDetailsPopup-module__m-b-6___cc6Cl`,
	"mB8": `ResultsDetailsPopup-module__m-b-8___I178X`,
	"mB10": `ResultsDetailsPopup-module__m-b-10____K3Dq`,
	"mB14": `ResultsDetailsPopup-module__m-b-14___o09sw`,
	"mB16": `ResultsDetailsPopup-module__m-b-16___V7B6b`,
	"mB20": `ResultsDetailsPopup-module__m-b-20___YUr6z`,
	"mB22": `ResultsDetailsPopup-module__m-b-22___hNIRw`,
	"mB24": `ResultsDetailsPopup-module__m-b-24___IYTz9`,
	"mB30": `ResultsDetailsPopup-module__m-b-30___IrkcA`,
	"mB32": `ResultsDetailsPopup-module__m-b-32___JRNrq`,
	"mB40": `ResultsDetailsPopup-module__m-b-40___eMrZ9`,
	"mT2": `ResultsDetailsPopup-module__m-t-2___R81rG`,
	"mT3": `ResultsDetailsPopup-module__m-t-3___aqHio`,
	"mT4": `ResultsDetailsPopup-module__m-t-4___HTJgY`,
	"mT5": `ResultsDetailsPopup-module__m-t-5___fcPgi`,
	"mT8": `ResultsDetailsPopup-module__m-t-8___O_2Na`,
	"mT10": `ResultsDetailsPopup-module__m-t-10___Gt3nJ`,
	"mT15": `ResultsDetailsPopup-module__m-t-15___uDk0s`,
	"mT16": `ResultsDetailsPopup-module__m-t-16___wqxTo`,
	"mT20": `ResultsDetailsPopup-module__m-t-20___B9WQo`,
	"mT22": `ResultsDetailsPopup-module__m-t-22___aXBVM`,
	"mT30": `ResultsDetailsPopup-module__m-t-30___cRzSc`,
	"mT32": `ResultsDetailsPopup-module__m-t-32___mzrOM`,
	"mLAuto": `ResultsDetailsPopup-module__m-l-auto___TKouw`,
	"mL4": `ResultsDetailsPopup-module__m-l-4___pmxuF`,
	"mL5": `ResultsDetailsPopup-module__m-l-5___l7yyu`,
	"mL6": `ResultsDetailsPopup-module__m-l-6___uHAcI`,
	"mL8": `ResultsDetailsPopup-module__m-l-8___Rmrb5`,
	"mL10": `ResultsDetailsPopup-module__m-l-10___fidbS`,
	"mL16": `ResultsDetailsPopup-module__m-l-16___njBJV`,
	"mL20": `ResultsDetailsPopup-module__m-l-20___qyQrm`,
	"mL24": `ResultsDetailsPopup-module__m-l-24___vjjHB`,
	"mL30": `ResultsDetailsPopup-module__m-l-30___nVx_W`,
	"mL35": `ResultsDetailsPopup-module__m-l-35___Dz6U0`,
	"mL40": `ResultsDetailsPopup-module__m-l-40___IkFT6`,
	"mR8": `ResultsDetailsPopup-module__m-r-8___E9iXS`,
	"mR10": `ResultsDetailsPopup-module__m-r-10___pUJE9`,
	"mR16": `ResultsDetailsPopup-module__m-r-16___tTc1q`,
	"mR20": `ResultsDetailsPopup-module__m-r-20___plZ2p`,
	"mR24": `ResultsDetailsPopup-module__m-r-24___QtjcJ`,
	"mR30": `ResultsDetailsPopup-module__m-r-30___YHO__`,
	"mR40": `ResultsDetailsPopup-module__m-r-40___NYk2U`,
	"borderR3": `ResultsDetailsPopup-module__border-r-3___UWWmy`,
	"borderR4": `ResultsDetailsPopup-module__border-r-4___gPdwo`,
	"borderR6": `ResultsDetailsPopup-module__border-r-6___ZPqQq`,
	"borderR10": `ResultsDetailsPopup-module__border-r-10___Gc_a4`,
	"borderR12": `ResultsDetailsPopup-module__border-r-12___pFsvT`,
	"borderR16": `ResultsDetailsPopup-module__border-r-16___i2xP9`,
	"borderR50": `ResultsDetailsPopup-module__border-r-50___kvTPJ`,
	"primaryBorder": `ResultsDetailsPopup-module__primary-border___aYMu0`,
	"primaryBorderB": `ResultsDetailsPopup-module__primary-border-b___CYxuN`,
	"primaryBorderT": `ResultsDetailsPopup-module__primary-border-t___WUOWr`,
	"primaryBorderL": `ResultsDetailsPopup-module__primary-border-l___ZhHVk`,
	"primaryBorderR": `ResultsDetailsPopup-module__primary-border-r___DQVPw`,
	"secondaryBorder": `ResultsDetailsPopup-module__secondary-border___Ibbu_`,
	"secondaryBorderB": `ResultsDetailsPopup-module__secondary-border-b___r5SMP`,
	"secondaryBorderT": `ResultsDetailsPopup-module__secondary-border-t___RbNMP`,
	"secondaryBorderL": `ResultsDetailsPopup-module__secondary-border-l___Kyx3L`,
	"secondaryBorderR": `ResultsDetailsPopup-module__secondary-border-r___g62Ic`,
	"gap0": `ResultsDetailsPopup-module__gap-0___LUB7t`,
	"gap2": `ResultsDetailsPopup-module__gap-2___ifpij`,
	"gap4": `ResultsDetailsPopup-module__gap-4___pI37n`,
	"gap5": `ResultsDetailsPopup-module__gap-5___sAiCQ`,
	"gap6": `ResultsDetailsPopup-module__gap-6___blFvT`,
	"gap8": `ResultsDetailsPopup-module__gap-8___VS16g`,
	"gap10": `ResultsDetailsPopup-module__gap-10___n4C5B`,
	"gap12": `ResultsDetailsPopup-module__gap-12___rqTxu`,
	"gap14": `ResultsDetailsPopup-module__gap-14___h1DI_`,
	"gap16": `ResultsDetailsPopup-module__gap-16___O0s96`,
	"gap18": `ResultsDetailsPopup-module__gap-18___BdijS`,
	"gap20": `ResultsDetailsPopup-module__gap-20___xJ1dA`,
	"gap24": `ResultsDetailsPopup-module__gap-24___DHjro`,
	"gap26": `ResultsDetailsPopup-module__gap-26___puvD5`,
	"gap30": `ResultsDetailsPopup-module__gap-30___MmSwY`,
	"gap32": `ResultsDetailsPopup-module__gap-32____0MA7`,
	"gap40": `ResultsDetailsPopup-module__gap-40___SHm9N`,
	"gap50": `ResultsDetailsPopup-module__gap-50___QdWNT`,
	"flex1": `ResultsDetailsPopup-module__flex-1___BPDyB`,
	"flexNone": `ResultsDetailsPopup-module__flex-none___oqgRi`,
	"flexColumn": `ResultsDetailsPopup-module__flex-column___YdfKr`,
	"flexRow": `ResultsDetailsPopup-module__flex-row___aTRLO`,
	"verticallyCentered": `ResultsDetailsPopup-module__vertically-centered___JpeN6`,
	"horizontallyCentered": `ResultsDetailsPopup-module__horizontally-centered___S35_t`,
	"horizontallyEnd": `ResultsDetailsPopup-module__horizontally-end___afyWV`,
	"verticallyStart": `ResultsDetailsPopup-module__vertically-start___zHO_b`,
	"spaceBetween": `ResultsDetailsPopup-module__space-between___Fdd4z`,
	"flexWrap": `ResultsDetailsPopup-module__flex-wrap___GIPnQ`,
	"height100": `ResultsDetailsPopup-module__height-100___hfYuW`,
	"width50": `ResultsDetailsPopup-module__width-50___gkJg2`,
	"width100": `ResultsDetailsPopup-module__width-100___qx19P`,
	"cursorPointer": `ResultsDetailsPopup-module__cursor-pointer___F5uUw`,
	"cursorNotAllowed": `ResultsDetailsPopup-module__cursor-not-allowed___sBDsM`,
	"absoluteCentered": `ResultsDetailsPopup-module__absolute-centered___nqLGr`,
	"absolute": `ResultsDetailsPopup-module__absolute___eSCgk`,
	"relative": `ResultsDetailsPopup-module__relative___XoQsS`,
	"fixed": `ResultsDetailsPopup-module__fixed___d8Zrr`,
	"visible": `ResultsDetailsPopup-module__visible___j37eW`,
	"invisible": `ResultsDetailsPopup-module__invisible___RYxxK`,
	"col90": `ResultsDetailsPopup-module__col-90___w1Mgs`,
	"colAuto": `ResultsDetailsPopup-module__col-auto___tgFtJ`,
	"medicalTabs": `ResultsDetailsPopup-module__medical-tabs___fa8pe`,
	"medicalTableNew": `ResultsDetailsPopup-module__medical-table-new___Mzlug`,
	"noPagination": `ResultsDetailsPopup-module__no-pagination___uc2kR`,
	"medicalTableEmpty": `ResultsDetailsPopup-module__medical-table-empty___qShbi`,
	"iconBtn": `ResultsDetailsPopup-module__icon-btn___OCCrb`,
	"searchIcon": `ResultsDetailsPopup-module__search-icon___KPrXy`,
	"disableSelect": `ResultsDetailsPopup-module__disable-select___W37BC`,
	"breakWord": `ResultsDetailsPopup-module__break-word___xpopx`,
	"popupClearBtn": `ResultsDetailsPopup-module__popup-clear-btn___W_oa3`,
	"scrollMB20": `ResultsDetailsPopup-module__scroll-m-b-20___gd2PD`,
	"info": `ResultsDetailsPopup-module__info___NV7nt`,
	"source": `ResultsDetailsPopup-module__source___yHlwL`,
	"category": `ResultsDetailsPopup-module__category___pLgBz`,
	"date": `ResultsDetailsPopup-module__date___xp3LV`,
	"table": `ResultsDetailsPopup-module__table___KaAer`
};
module.exports = ___CSS_LOADER_EXPORT___;
